module.exports = __webpack_public_path__ + "static/media/oswaldo_aranda_1.63227391.jpg";